import type { PieChartModel } from "@/types/dashboard";
import { SvgPieChart } from "./SvgPieChart";

interface LabeledPieChartProps {
  data: PieChartModel[];
  showLabels?: boolean;
  selectedBusiness?: string | null;
}
export function LabeledPieChart({ data, showLabels = true, selectedBusiness = null }: LabeledPieChartProps) {
  if (!data || data.length === 0) return null;

  const safeData = data.filter((d) => d.segmentValue > 0);
  if (safeData.length === 0) return null;

  const total = safeData.reduce((sum, d) => sum + d.segmentValue, 0);
  if (total === 0) return null;

  const dataWithPercentages = safeData.map((segment) => {
    const pct = Math.round((segment.segmentValue / total) * 100);
    const labelValue = `${segment.segmentValueString} (${pct}%)`;

    return {
      ...segment,
      segmentValueString: labelValue,
    };
  });

  return (
    <SvgPieChart
      data={dataWithPercentages}
      selectedBusiness={selectedBusiness ?? "All Businesses"}
    />
  );
}
